import React from 'react'

function SupportConsole() {
  return (
    <div className='pageComingAlign'>Coming Soon...</div>
  )
}

export default SupportConsole